module.exports = __webpack_public_path__ + "img/img_logo.605ff9f7.png";